import type { SortKey, SortOption } from '@/features/project-board/sorting';

/**
 * 목록 정렬 선택.
 *
 * 공용 select 컴포넌트가 없어 `DevRequestView`의 담당자 선택과 같은 형태를 쓴다. 보기 모드
 * 토글(`ViewModeToggle`)과 나란히 놓이므로 높이·글자 크기를 그쪽에 맞춘다.
 */
export function SortPicker({
  options,
  value,
  onChange,
  label = '정렬',
}: {
  options: ReadonlyArray<SortOption>;
  value: SortKey;
  onChange: (next: SortKey) => void;
  label?: string;
}): React.JSX.Element {
  return (
    <select
      value={value}
      onChange={(event) => onChange(event.target.value as SortKey)}
      aria-label={label}
      className="rounded-md border border-line bg-surface px-2 py-1 text-[12px]"
    >
      {options.map((option) => (
        <option key={option.key} value={option.key}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
